import { render, staticRenderFns } from "./InstallPWAiOS.vue?vue&type=template&id=20a33ac9&scoped=true&"
import script from "./InstallPWAiOS.vue?vue&type=script&lang=js&"
export * from "./InstallPWAiOS.vue?vue&type=script&lang=js&"
import style0 from "./InstallPWAiOS.vue?vue&type=style&index=0&id=20a33ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a33ac9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon})
